var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetailersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2.5C2 1.119 3.119 0 4.5 0C5.881 0 7 1.119 7 2.5C7 3.881 5.881 5 4.5 5C3.119 5 2 3.881 2 2.5ZM6 15H2V9C2 8.448 2.449 8 3 8H15V6H3C1.346 6 0 7.346 0 9V17H2V24H4V17H6V24H8V10H6V15ZM24 18.5V24H10V18.5C10 17.121 11.122 16 12.5 16H13V12.5C13 11.121 14.122 10 15.5 10H18.5C19.878 10 21 11.121 21 12.5V16H21.5C22.878 16 24 17.121 24 18.5ZM15 16H19V12.5C19 12.225 18.776 12 18.5 12H15.5C15.224 12 15 12.225 15 12.5V16ZM16 18.5C16 18.225 15.776 18 15.5 18H12.5C12.224 18 12 18.225 12 18.5V22H16V18.5ZM22 18.5C22 18.225 21.776 18 21.5 18H18.5C18.224 18 18 18.225 18 18.5V22H22V18.5Z",
    fill: "#0084D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailersIcon);
export default __webpack_public_path__ + "static/media/retailers-icon.13daacad55769a81afaba5168e5a9a52.svg";
export { ForwardRef as ReactComponent };